export const HOTEL_AVAILABILITY_TEXT = "Choose hotel";
export const HOTEL_DETAILS_TEXT = "Choose room";
export const FLIGHT_OUTBOUND_SHOP = "Outbound flight";
export const FLIGHT_RETURN_SHOP = "Return flight";
export const REVIEW_PACKAGE = "Review package";
export const CONFIRM_AND_BOOK = "Confirm and book";
